export default "__VITE_ASSET__PX5zs3aZ__"